import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root'
})

export class TitleService {
  private titlePrefixBase = 'Optinex';
  private title = inject(Title);


  public titlePrefix():string{
    if (environment.environment === 'prod') {
      return this.titlePrefixBase;
    } else {
      return `${this.titlePrefixBase} (${environment.environment})`;
    }
  }

  public resetTitle(){
    this.title.setTitle(this.titlePrefix());
  }
}
